import React from 'react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
class LocationSearchInput extends React.Component<
  { locationDetail: any; value: any; disabled?: any; handleAddressChange?: any },
  { address: string; disabled?: any }
> {
  constructor(props: any) {
    console.log("LocationSearchInput props", props)
    super(props);
    this.state = {
      disabled: props.disabled,
      address: props.value,
    };
  }

  handleChange = (address: any) => {
    this.setState({ address });
  };

  componentDidMount() {
    if (this.state.address) {
      this.handleSelect(this.state.address);
    }
  }

  componentDidUpdate(prevProps: any) {
    if (this.props.value != prevProps.value) {
      this.setState({ address: this.props.value });
      this.handleSelect(this.props.value);
    }
  }

  handleSelect = (address: any) => {
    let locationDetail: any = {};
    geocodeByAddress(address).then(
      (response) => {
        response.map((value: any) => {
          locationDetail.formatted_address = value.formatted_address;
          locationDetail.lat = value.geometry.location.lat();
          locationDetail.lng = value.geometry.location.lng();
          value.address_components.map((location: any) => {
            if (location.types.includes('postal_code')) locationDetail.postalcode = location.long_name;
            if (location.types.includes('country')) locationDetail.country = location.long_name;
            if (location.types.includes('administrative_area_level_1')) locationDetail.state = location.long_name;
            if (location.types.includes('locality')) {
              locationDetail.city = location.long_name;
            }
          });
        });
        this.props.locationDetail(locationDetail);
        this.setState({ address: locationDetail.formatted_address });
      },
      (error) => {
        console.error(error);
      }
    );
  };
  render() {
    const { address } = this.state;
    return (
      <PlacesAutocomplete value={address} onChange={this.handleChange} onSelect={this.handleSelect}>
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <input
              {...getInputProps({
                placeholder: 'Search Places ...',
                className: 'location-search-input',
              })}
              disabled={this.state.disabled}
              style={{ padding: '15px', width: '100%', borderRadius: '8px' }}
              name="address"
              id="address"
              required
            />
            <div className="autocomplete-dropdown-container">
              {loading && <div>Loading...</div>}
              {suggestions.map((suggestion, index) => {
                const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                // inline style for demonstration purpose
                const style = suggestion.active
                  ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                  : { backgroundColor: '#ffffff', cursor: 'pointer' };
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}
                    key={index + '1'}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    );
  }
}
export default LocationSearchInput;
